<template>
    <div class="graphic__container">

        <div class="graphic">
            <PieChart v-if="graph.datasets[0].data.length > 0" :chartData="graph" :options="graphicOptions"/>
        </div>

        <div class="graphic-labels">
            <div v-for="(value,property) in graphicColors" :key="property" class="graphic-label">
                <div class="graphic-label__color" :style="{backgroundColor: commonColors[value]}"></div>
                <span>{{$t(`tutor.report.userSituation.${property}`)}}: <strong>{{getValue(property)}}</strong></span>
            </div>
        </div>

    </div>
</template>

<script>
import { PieChart } from 'vue-chart-3';
import { Chart, registerables } from "chart.js";
import { onMounted, ref } from 'vue';
Chart.register(...registerables);

export default {
    components:{
        PieChart,
    },
    props: {
        //title: String,
        graphicColors: Object,
        graphicData: Array,
    },
    setup(props, { emit }){
        const graph = ref({ labels: [],datasets: [ { data: [], backgroundColor: [] } ] });
        const itemLabels = ref([]);
        const itemValues = ref([]);
        const commonColors = {
            red: '#F62E53',
            lightred: '#DE5D00',
            yellow: '#F3BF3D',
            lightgreen: '#00A94E',
            green: '#009696'
        }
        const graphicOptions = {
            plugins: {
                tooltip: {
                    enabled: true,
                    //mode: 'single',
                    callbacks: {
                        label: function (tooltipItems) {
                            return  ` ${tooltipItems.formattedValue}%`;
                        }
                    },     
                    legend: {
                        display:false,
                    }
                }
            },
            onClick: (e,dataIndex)=>{
                emit('filterReport',itemLabels.value[dataIndex[0].index])
            },
        }

        const loadGraphicData = (items) => {
            items.forEach(item => {    
                graph.value.datasets[0].data.push(item.percentage);
                graph.value.datasets[0].backgroundColor.push(commonColors[props.graphicColors[item.name]]);
                itemLabels.value.push(item.name);
                itemValues.value.push({name:item.name,valor:item.value});
            });
        }
       onMounted(()=>{
            loadGraphicData(props.graphicData);
        })

        function getValue(property){
            let index = itemValues.value.findIndex(item => item.name == property);
            if(index >=0) return itemValues.value[index].valor;
            else return 0;
        }

        return{
            graph,
            commonColors,
            graphicOptions,
            itemValues,
            getValue
        }
    },
}
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.graphic__container{
    width: fit-content;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 66px;
    .graphic{
        >div{
            height: 240px;
        }
    }
    .graphic-labels{
        padding-top: 20px;
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: flex-start;
        gap: 42px;
        .graphic-label{
            width: 100%;
            padding-left: 4px;
            display: flex;
            align-items: center;
            gap: 8px;
            &__color{
                margin-top: 1px;
                width: 32px;
                height: 12px;
                border-radius: 4px;
            }
            span{
                font-size: 14px;
                color: $black;
                font-weight: 600;
            }         
        }
    }
}
</style>
